module.exports = __webpack_public_path__ + "img/mobile_0.ec090717.png";